interface FAQ {
  question: string;
  answer: string;
  category?: string;
}

const FAQContent: FAQ[] = [
  {
    question: 'Was sind Widgets?',
    answer: `Widgets sind kleine, eigenständige interaktive Elemente, die in deine Webseite eingefügt werden können. FuPa Widgets bieten eine unkomplizierte Möglichkeit, deine Vereinswebsite mit Teaminhalten schnell und flexibel zu erweitern.`,
    category: 'general',
  },
  {
    question: 'Was sind die Voraussetzungen, um die Widgets zu nutzen?',
    answer:
      'Damit du ein Widget erstellen und speichern kannst, benötigst du lediglich ein FuPa-Konto. Du hast noch kein FuPa-Konto? <a style="color: #0096db" href="https://www.fupa.net/auth/signup" target="_blank">Jetzt kostenlos registrieren!</a>',
    category: 'general',
  },
  {
    question: 'Ist die Nutzung der Widgets mit Kosten verbunden?',
    answer: 'Nein, die Nutzung der Widgets ist kostenlos.',
    category: 'general',
  },
  {
    question: 'Muss ich das Widget in meinem Cookie-Banner / meiner CMP angeben?',
    answer: `
Ja, als Website-Betreiber bist du dafür verantwortlich, das Widget datenschutzkonform einzubinden. Hierzu musst du es im Cookie-Banner / CMP als neuen Dienst (Vendor) anlegen. Bitte stelle sicher, dass das Widget-Skript (widget-api.fupa.net/vendor/widget.js?v1) durch das CMP so lange blockiert wird, bis der Nutzer seine Zustimmung erteilt hat.
              <br/>
              Bitte verwende beim Anlegen des Dienstes in deinem CMP die folgenden Daten:
              <ul>
                <li>Name des Dienstes / Anbieters: FuPa Widget (FuPa GmbH)</li>
                <li> Kategorie: Externe Medien / Widgets (oder eine vergleichbare Kategorie in deinem CMP)</li>
                <li> Zwecke der Datenverarbeitung: Ausspielung und Darstellung von sportlichen Inhalten (Tabellen, Spielpläne, Kader, Statistiken) auf der Website. Sicherstellung der technischen Funktion und Stabilität des Widgets.</li>
                <li> Verarbeitete Daten: IP-Adresse des Nutzers (notwendig für den Verbindungsaufbau). Browser-Informationen (User-Agent, Referrer-URL). Technisch bedingt: Vorhandene Cookies der Domain .fupa.net (sofern der Nutzer FuPa in der Vergangenheit direkt besucht hat).</li>
                <li> Rechtsgrundlage: Einwilligung / Consent (Art. 6 Abs. 1 lit. a DSGVO sowie § 25 Abs. 1 TDDDG).</li>
                <li> Ort der Verarbeitung (Serverstandort): Deutschland / Europäische Union (EU).</li>
                <li>Speicherdauer: IP-Adressen werden auf den Servern von FuPa automatisch nach 7 Tagen anonymisiert.</li>
                <li>Weitergabe an Dritte: Keine. (Die Verarbeitung erfolgt im Rahmen eines Vertrags zur Auftragsverarbeitung (AVV) ausschließlich durch die FuPa GmbH).</li>
                <li>Link zur Datenschutzerklärung des Anbieters: https://www.fupa.net/about/privacy-policy</li>
                <li>Link zu den Nutzungsbedingungen (inkl. AVV): https://support.fupa.net/support/solutions/articles/75000119348-nutzungsbedingungen-der-fupa-widgets-für-webseitenbetreiber-nutzer-</li>
              </ul>
    `,
    category: 'general',
  },
  {
    question: 'Wie binde ich ein einzelnes Widget auf meiner Webseite ein?',
    answer: `Um ein einzelnes Widget auf deiner Webseite einzubinden, folge diesen Schritten:
                <ol>
                  <li>Nutze den FuPa Widget-Builder, um das gewünschte Widget zu erstellen.</li>
                  <li>Nachdem du das Widget erstellt hast, wird dir ein Code angezeigt. Kopiere diesen Code.</li>
                  <li>Füge den kopierten Widget-Code an der gewünschten Stelle in den HTML-Quellcode deiner Webseite ein.</li>
                </ol>
                Wichtig: Achte darauf, dass der kopierte Code unverändert bleibt und nicht gekürzt wird. Wenn dein Editor automatische Änderungen vornimmt, empfehlen wir die Verwendung eines Plugins, dass das Einfügen von individuellem HTML in deine Webseite ermöglicht.
             `,
    category: 'integration',
  },
  {
    question: 'Ich möchte mehrere einzelne Widgets auf einer Seite meiner Webseite einbinden. Wie mache ich das?',
    answer:
      'Die Einbindung mehrerer einzelner Widgets auf einer Seite erfolgt genauso wie bei einem einzelnen Widget.<br/> Du kannst beliebig viele Widgets auf einer Seite einfügen und die entsprechenden Codes an gewünschter Stelle platzieren.<br/> Bei der Platzierung mehrerer Widgets empfehlen wir das Script<br/><em style="font-family: monospace; font-size: 14px">&lt;script src="https://widget-api.fupa.net/vendor/widget.js?v1"&gt;&lt;/script&gt;</em> einmalig im <em style="font-family: monospace; font-size: 14px">&lt;head&gt;</em>-Bereich einzubinden anstatt es bei jedem einzelnen Widget-Code im &lt;body&gt; zu platzieren. Das Script ist bei allen Widgets identisch und wird deshalb nur einmal benötigt.',
    category: 'integration',
  },
  {
    question: 'Muss der Code eines eingebundenen Widgets zum Saisonwechsel aktualisiert werden?',
    answer:
      'Nein, eine Aktualisierung des Codes ist nicht nötig. Im Gegensatz zu den alten FuPa Widgets, die ein Austauschen des Codes zur Aktualisierung erforderten, erkennt das neue Widget automatisch den Saisonwechsel.',

    category: 'integration',
  },
  {
    question:
      'Ich habe bereits ein altes Widget auf meiner Seite eingebunden. Wie kann ich die neuen Widgets verwenden?',
    answer: `
        Die neuen Widgets funktionieren eigenständig und es ist nicht möglich, die alten Widget-Codes automatisch auf
        die neuen Widgets zu übertragen. Um die neuen Widgets zu nutzen, befolgen diese Schritte:
        <ol>
          <li>Verwende unseren neuen Widget-Builder, um die Widgets zu erstellen, die du benötigst.</li>
          <li>
            Ersetze die alten Widget-Einbindungen auf deiner Webseite durch die neuen. Siehe hierzu auch “Wie binde ich
            ein Widgets auf meiner Webseite ein?”.
          </li>
        </ol>`,

    category: 'integration',
  },
  {
    question:
      'Ich habe bereits ein altes Widget auf meiner Seite eingebunden. Werden die alten Widgets weiterhin unterstützt?',
    answer:
      'Ja, die alten Widgets werden vorerst weiterhin unterstützt. Die alten und die neuen Widgets können sogar gleichzeitig auf der Webseite eingebunden werden. Wir empfehlen aber, auf die neuen Widgets zu wechseln, da diese nicht nur technisch auf dem neuesten Stand sind, sondern sich auch auf allen Geräten optimal darstellen lassen.',

    category: 'integration',
  },
  {
    question: 'Wird das Widget auf Mobilgeräten richtig angezeigt?',
    answer:
      'Ja, unsere neuen FuPa Widgets sind mobil optimiert und bieten eine reibungslose und benutzerfreundliche Darstellung auf Smartphones, Tablets und anderen Geräten. Deine Website-Besucher können die Informationen und Funktionen der FuPa Widgets auf allen Geräten uneingeschränkt nutzen.',
    category: 'integration',
  },
  {
    question: 'Wie füge ich das Widget am besten in Wordpress ein?',
    answer: `Die Einbindung des Widgets in WordPress ist einfach:
        <ol><li>Kopiere den Widget-Code von FuPa.</li>
        <li>Melde dich in deinem WordPress-Dashboard an.</li>
        <li>Gehe zu der Seite oder dem Beitrag, auf der/dem du das Widget anzeigen möchtest.
          <ul>
            <li>Option 1: Füge im visuellen Editor den Block “individuelles HTML” hinzu.</li>
            <li>Option 2: Wechsle in den "Text"-Editor-Modus (anstatt des visuellen Editors).</li>
          </ul>
        </li>
        <li>Füge den kopierten Widget-Code an der gewünschten Stelle ein.</li>
        <li>Speichere oder aktualisiere die Seite bzw. den Beitrag.</li>
        </ol>
Das Widget sollte nun auf deiner WordPress-Seite sichtbar sein. Beachte, dass je nach WordPress-Theme und Plugins möglicherweise zusätzliche Anpassungen erforderlich sein können.

`,
    category: 'integration',
  },
  {
    question: 'Wie füge ich das Widget am besten in Joomla ein?',
    answer: `Die Einbindung des Widgets in Joomla ist einfach:
        <ol><li>Kopiere den Widget-Code von FuPa.</li>
          <li>Melde dich in deinem Joomla-Administratorbereich an.</li>
          <li>Gehe zu "Inhalt" und wähle "Module" aus.</li>
          <li>Klicke auf "Neu" und wähle "Benutzerdefiniertes HTML" oder "Modul" aus, je nachdem, wie du das Widget einbinden möchtest.</li>
          <li>Füge den kopierten Widget-Code in das Textfeld oder den HTML-Bereich des Moduls ein.</li>
          <li>Konfiguriere die Modulposition und Zuweisungen nach Bedarf.</li>
          <li>Speichere das Modul und weise es den gewünschten Seiten oder Menüpunkten zu.</li>
        </ol>
Das Widget sollte nun auf deiner Joomla-Website sichtbar sein. Beachte, dass je nach Joomla-Version und Template möglicherweise zusätzliche Anpassungen erforderlich sein können.
`,
    category: 'integration',
  },
  {
    question: 'Welche Daten können mit den Widgets dargestellt werden?',
    answer: `Unsere Widgets für <strong>"Team"</strong> bieten derzeit folgende Ansichten:
                <ul>
                  <li><strong>Tabelle:</strong> Die Ligatabelle des ausgewählten Teams in der aktuellen Saison.</li>
                  <li><strong>Kader:</strong> Die Spieler des ausgewählten Teams in der aktuellen Saison.</li>
                  <li><strong>Spielerstatistik:</strong> Rangliste der Spieler in der aktuellen Saison mit Details wie Toren, Spielen, Karten, Minuten und vielen mehr. 
                  <li><strong>Spielplan:</strong> Der vollständige Spielplan des Teams in der aktuellen Saison, mit der Möglichkeit, Spiele nach Wettbewerben einzuschränken.</li>
                  <li><strong>Liveticker:</strong> Das aktuelle Spiel des Teams mit der Möglichkeit der Darstellung von ausführlichen Schilderungen zum Spielgeschehen oder lediglich den Live-Zwischenständen. Vorraussetzung ist hier die Begleitung des Spiels durch einen FuPa-Tickermelder.</li>
                </ul><p/>
                Unsere Widgets für  <strong>"Spiel"</strong> bieten derzeit folgende Ansichten:
                <ul>
                  <li><strong>Liveticker:</strong> Abbilden eines expliziten Spiels. Einmal erstellt, kann die Ansicht dauerhaft eingebunden bleiben und zeigt immer das komplette Spielgeschehen vor, während und nach der ausgewählten Partie. Erstellt werden können Widgets mit Spielen innerhalb von +/- 30 Tagen.</li>
                </ul>`,
    category: 'data',
  },
  {
    question: 'Wie kann ich die in den Widgets angezeigten Daten hinzufügen oder aktualisieren?',
    answer:
      'Es ist einfach: Melde dich an und <a style="color: #0096db" href="https://admin.fupa.net/fupa/admin/index.php?page=permissions" target="_blank"> beantrage zunächst die Vereinsverwalterschaft</a> für deinen Verein auf FuPa, falls du noch kein Vereinsverwalter bist. Danach kannst du die Daten für alle Teams in deinem Verein hinzufügen oder aktualisieren.',
    category: 'data',
  },
  {
    question: 'Wie kann die Farbe des Widgets angepasst werden?',
    answer:
      'Du kannst die Grundfarbe und Schriftfarbe im Widget-Builder mithilfe der Farbpicker auswählen. Benötigst du spezifische Anpassungen für einzelne Elemente innerhalb der Widget-Ansicht, dann verwende den CSS-Editor. Aktiviere den CSS-Editor über den Toggle "Entwickler-Optionen" in der Sidebar des Widget-Builders.',
    category: 'design',
  },
  {
    question: 'Wie kann die Größe des Widgets angepasst werden?',
    answer:
      'Das Widget passt sich automatisch an die Breite und Höhe des Elements an, in das der Widget-Code auf der Webseite eingefügt wird. Eine Anpassung der Größe des Widgets selbst ist daher in der Regel nicht erforderlich, da sie immer über die Höhe und Breite des umgebenden Elements gesteuert werden kann. Um jedoch mögliche Designprobleme zu verhindern, wurde die maximale Breite, die das Widget einnimmt, auf 970px begrenzt.',
    category: 'design',
  },
  {
    question: 'Wie kann ich eine eigene Schrift verwenden?',
    answer:
      'Du kannst aus einer Grundauswahl an Schriftarten in der Sidebar des Widget-Builders wählen. Wenn du eine spezielle Schriftart benötigst, füge sie einfach über den CSS-Editor mit der CSS-Anweisung <em>@font-face</em> hinzu. Den CSS-Editor aktivierst du über den Toggle “Entwickler-Optionen” in der Sidebar des Widget-Builders.',

    category: 'design',
  },
  {
    question:
      'Ich habe nachträglich die Styles oder Einstellungen eines bereits eingebundenen Widgets bearbeitet. Muss ich den Code auf meiner Webseite austauschen?',
    answer:
      'Nein, du musst den Code nicht austauschen. Die neuen Styles, hinzugefügten Ansichten oder Konfigurationsänderungen für das Team werden automatisch innerhalb weniger Minuten auf deiner Webseite aktualisiert.',
    category: 'design',
  },
  {
    question: 'Von unserem Verein finde ich keine Jugendmannschaften. Was kann ich machen?',
    answer:
      'In zahlreichen FuPa-Regionen werden nur Teams und Ligen aus dem Erwachsenenbereich angelegt. Wenn von deinem Verein - in aller Regel - U11- / U9- oder andere “Bambini”-Teams fehlen, bedeutet das, dass sich die jeweilige FuPa-Region gegen das Erfassen von Daten dieser Teams entschieden hat. In diesem Fall ist auch das Anlegen eines Widgets nicht möglich. ',
    category: 'data',
  },
  {
    question:
      'Ich nutze Plugins zur Optimierung meiner Dateien und Caching innerhalb meines CMS, wie WP Rocket. Das Widget wird dadurch nicht korrekt dargestellt. Wie kann ich das verhindern?',
    answer:
      'Die Nutzung von Plugins zur Datei-Optimierung oder Caching, wie WP Rocket kann die Darstellung des Widgets beeinflussen oder sogar brechen. Je nachdem wie das Plugin konfiguriert ist, kann ein zu langes Caching dazuführen, dass trotz Aktualisierung des Widget-Codes auf der Seite nicht das zugehörige Skript mitausgeliefert wird und das Widget nicht korrekt dargestellt wird. In diesem Fall empfehlen wir, das Widget-Script von der Optimierung auszuschließen. Wie das geht, erfährst du in der <a style="color: #0096db" href="https://docs.wp-rocket.me/article/1384-disable-page-cache-for-specific-pages-and-posts" target="_blank">Dokumentation von WP Rocket</a>.',
    category: 'error',
  },
  {
    question:
      'Das Widget zeigt nach der Einbindung eine Fehlermeldung oder wird gar nicht dargestellt. An wen kann ich mich wenden?',
    answer:
      'Bevor du dich an uns wendest, lies dir bitte zuerst unsere FAQs zum Thema “Einbindung auf der Webseite” durch. Falls das Problem weiterhin besteht, kontaktiere bitte unseren Support unter  <a style="color: #0096db" href="mailto:support@fupa.net?subject=Widget-Probleme">support@fupa.net</a> mit dem Betreff "Widget-Probleme". Teile uns mit, welches Widget (ID) du auf welcher Seite integrieren möchtest. Wir helfen dir gerne weiter.',
    category: 'error',
  },
];

export {FAQContent, FAQ};
